import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const ruleSets = api(async function ruleSets({ skip, take, search, sort, descending, status }) {
    return query(
        gql`
            query GetRuleSets(
                $skip: Int
                $take: Int
                $search: String
                $sort: RuleSetSort
                $descending: Boolean
                $status: String
            ) {
                ruleSets(
                    skip: $skip
                    take: $take
                    search: $search
                    sort: $sort
                    descending: $descending
                    status: $status
                ) {
                    totalCount
                    items {
                        id
                        name
                        description
                        type
                        defaultAction
                        rules {
                            id
                            type
                            name
                            combinator
                            enabled
                            ruleSetId
                            ruleSetName
                            conditions {
                                field
                                operator
                                value
                            }
                            action {
                                type
                                multiplier
                                costKind
                                fixedAmount
                                timeKind
                                timeValue
                                frequencyMultiplier
                            }
                        }
                        isArchived
                        created
                        modified
                        usedByCount
                        usedByScenarios {
                            id
                            name
                            variantName
                        }
                        parentRuleSetId
                        parentRuleSetName
                    }
                }
            }
        `,
        { skip, take, search, sort, descending, status },
        { returns: "ruleSets" }
    )
})
